module.exports = __webpack_public_path__ + "img/08.full-moon-light.fbaa8e2e.svg";